<script lang="tsx">
import { defineComponent } from 'vue'
const [name, bem] = createNamespace('CommonTag')
import { Tag } from 'ant-design-vue'
import { createNamespace, extendSlots } from '@bd/vue3-utils'
export default defineComponent({
  name,
  inheritAttrs: false,
  setup(_, { attrs, slots }) {
    return () => (
      <Tag {...attrs} class={bem()}>
        {extendSlots(slots)}
      </Tag>
    )
  }
})
</script>
<style lang="less">
.common-tag {
  &.ant-tag {
    padding: 2px 8px;
    border: none;
  }
}
</style>
